import {login, logout, getInfo} from '@/api/user'
import {getToken, setToken, removeToken} from '@/utils/auth'
import router, {resetRouter} from '@/router'
import {Message, Notification} from 'element-ui'
import md5 from 'js-md5'
import moment from "moment";

// 初始状态
const state = {
    token: getToken(), 
    name: localStorage.getItem('userName') || '', 
    avatar: localStorage.getItem('userAvatar') || '', 
    introduction: '', 
    roles: [], 
    mobile: '', 
    id: localStorage.getItem('userId') || '', 
    realname: localStorage.getItem('userRealname') || '', 
    description: localStorage.getItem('userDescription') || '', 
    isPay: false,
    roleInfo: JSON.parse(localStorage.getItem('userRoleInfo') || 'null'),
    feishuOpenId: localStorage.getItem('userFeishuOpenId') || '',
}
// 修改状态
const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    }, SET_INTRODUCTION: (state, introduction) => {
        state.introduction = introduction
    }, SET_NAME: (state, name) => {
        state.name = name
        localStorage.setItem('userName', name)
    }, SET_AVATAR: (state, avatar) => {
        state.avatar = avatar || ''
        if (avatar) localStorage.setItem('userAvatar', avatar)
        else localStorage.removeItem('userAvatar')
    }, SET_ROLES: (state, roles) => {
        state.roles = roles
    }, SET_MOBILE: (state, mobile) => {
        state.mobile = mobile
    }, SET_LOGIN_ID: (state, id) => {
        state.id = id
        localStorage.setItem('userId', id)
    }, SET_IS_PAY: (state, isPay) => {
        state.isPay = isPay
    }, SET_PASSWORD: (state, password) => {
        // 密码存储逻辑
    }, SET_REALNAME: (state, realname) => {
        state.realname = realname
        localStorage.setItem('userRealname', realname)
    }, SET_DESCRIPTION: (state, description) => {
        state.description = description
        localStorage.setItem('userDescription', description)
    },
    SET_ROLE_INFO: (state, roleInfo) => {
        state.roleInfo = roleInfo
        localStorage.setItem('userRoleInfo', JSON.stringify(roleInfo))
    },
    SET_FEISHU_OPEN_ID: (state, openId) => {
        state.feishuOpenId = openId || ''
        if (openId) localStorage.setItem('userFeishuOpenId', openId)
        else localStorage.removeItem('userFeishuOpenId')
    },
    /** 从登录 / 绑定状态等接口同步飞书字段 */
    APPLY_FEISHU_USER: (state, payload = {}) => {
        const openId = payload.feishuOpenId
        const avatar = payload.feishuAvatar || payload.avatar
        const hasOpenId = openId != null && String(openId).trim() !== ''
        state.feishuOpenId = hasOpenId ? String(openId).trim() : ''
        if (hasOpenId) localStorage.setItem('userFeishuOpenId', state.feishuOpenId)
        else localStorage.removeItem('userFeishuOpenId')

        if (hasOpenId && avatar) {
            state.avatar = String(avatar).trim()
            localStorage.setItem('userAvatar', state.avatar)
        } else if (!hasOpenId) {
            state.avatar = ''
            localStorage.removeItem('userAvatar')
        }
    },
}

// 异步操作
const actions = {
    // 登录
    login({commit}, userInfo) {
        const {username, password} = userInfo
        commit('SET_PASSWORD', password)
        localStorage.setItem('SET_NAME', username)
        commit('SET_NAME', username)

        return new Promise((resolve, reject) => {
            login(userInfo).then(response => {
                const { data } = response
                console.log('Store login response:', response); // 打印Store登录响应
                if (response.code === 200) {
                    localStorage.setItem('token', data.token)
                    commit('SET_TOKEN', data.token)
                    setToken(data.token) // 将 token 存储到 Vuex 和 localStorage 中
                    
                    // 从登录响应中获取userInfo并设置到Vuex
                    const userInfo = data.userInfo || {}
                    commit('SET_NAME', userInfo.username)
                    commit('SET_REALNAME', userInfo.realname)
                    commit('SET_DESCRIPTION', userInfo.description || userInfo.remarks)
                    commit('SET_LOGIN_ID', userInfo.id)
                    commit('APPLY_FEISHU_USER', userInfo)

                    // 未绑定飞书：进入管理端后提示绑定
                    try {
                        const openId = userInfo.feishuOpenId
                        const unbound = openId == null || String(openId).trim() === ''
                        if (unbound) {
                            sessionStorage.setItem('lvxin-feishu-prompt-after-login', '1')
                        } else {
                            sessionStorage.removeItem('lvxin-feishu-prompt-after-login')
                        }
                    } catch (e) { /* ignore */ }
                    
                    // 存储roleInfo到Vuex
                    if (data.roleInfo) {
                        commit('SET_ROLE_INFO', data.roleInfo)
                    }
                    
                    resolve(response)
                } else {
                    console.error('Store login error:', error); // 打印Store登录错误
                    reject(new Error('账号或密码错误！'))
                }
            }).catch(error => {
                reject(error)
            })

            // login({email: username.trim(), password: md5Password, loginMode: 1}).then(response => {
            //   // 登录业务判断
            //   // ...
            //   resolve()
            // }).catch(error => {
            //   reject(error)
            // })
        })
    }, 
    // 获取用户信息
    getInfo({commit, state}) {
        return new Promise((resolve, reject) => {
            const tokens = getToken()
            getInfo(tokens).then(response => {
                // 检查响应结构，根据API响应截图，userInfo在response.data中
                const userInfo = response.data.userInfo || {}
                const data = {
                    roles: [], // 暂时设为空数组，根据实际API响应调整
                    name: userInfo.username, // 使用username作为name
                    mobile: '', // 暂时设为空，根据实际API响应调整
                    realname: userInfo.realname,
                    description: userInfo.description || userInfo.remarks
                }
                if (response.code !== 200) {
                    reject('请重新登录！')
                }
                const {roles, name, mobile, realname, description} = data
                commit('SET_ROLES', roles)
                commit('SET_NAME', name)
                commit('SET_MOBILE', mobile)
                commit('SET_REALNAME', realname)
                commit('SET_DESCRIPTION', description)
                commit('SET_LOGIN_ID', userInfo.id)
                
                // 存储roleInfo到Vuex
                if (response.data.roleInfo) {
                    commit('SET_ROLE_INFO', response.data.roleInfo)
                }
                
                resolve(data)
            }).catch(error => {
                console.log(error)
                reject(error)
            })
        })
    },

    // 登出
    logout({commit, state, dispatch}) {
        return new Promise((resolve, reject) => {
            logout(state.name).then(() => {
                // 清除Vuex中的token和用户信息
                commit('SET_TOKEN', '')
                commit('SET_ROLES', [])
                commit('SET_NAME', '')
                commit('SET_REALNAME', '')
                commit('SET_DESCRIPTION', '')
                commit('SET_LOGIN_ID', '')
                commit('SET_ROLE_INFO', null)
                commit('APPLY_FEISHU_USER', {})
                
                // 清除localStorage中的token和用户信息
                removeToken()
                localStorage.removeItem('SET_NAME')
                localStorage.removeItem('userName')
                localStorage.removeItem('userId')
                localStorage.removeItem('userRealname')
                localStorage.removeItem('userDescription')
                localStorage.removeItem('userRoleInfo')
                localStorage.removeItem('userAvatar')
                localStorage.removeItem('userFeishuOpenId')
                try { sessionStorage.removeItem('lvxin-feishu-prompt-after-login') } catch (e) { /* ignore */ }
                
                resetRouter()
                // reset visited views and cached views
                //dispatch('tagsView/delAllViews', null, {root: true})
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },

    // 重置token
    resetToken({commit}) {
        return new Promise(resolve => {
            // 清除Vuex中的token和用户信息
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            commit('SET_NAME', '')
            commit('SET_REALNAME', '')
            commit('SET_DESCRIPTION', '')
            commit('SET_LOGIN_ID', '')
            commit('SET_ROLE_INFO', null)
            commit('APPLY_FEISHU_USER', {})
            
            // 清除localStorage中的token和用户信息
            removeToken()
            localStorage.removeItem('SET_NAME')
            localStorage.removeItem('userName')
            localStorage.removeItem('userId')
            localStorage.removeItem('userRealname')
            localStorage.removeItem('userDescription')
            localStorage.removeItem('userRoleInfo')
            localStorage.removeItem('userAvatar')
            localStorage.removeItem('userFeishuOpenId')
            try { sessionStorage.removeItem('lvxin-feishu-prompt-after-login') } catch (e) { /* ignore */ }
            
            resolve()
        })
    },

    // 动态修改权限
    async changeRoles({commit, dispatch}, role) {
        const token = role + '-token'
        commit('SET_TOKEN', token)
        setToken(token)
        const {roles} = await dispatch('getInfo')
        resetRouter()
        // generate accessible routes map based on roles
        const accessRoutes = await dispatch('permission/generateRoutes', roles, {root: true})
        // dynamically add accessible routes
        router.addRoutes(accessRoutes)
        // reset visited views and cached views
       // dispatch('tagsView/delAllViews', null, {root: true})
    }
}

export default {
    namespaced: true, state, mutations, actions
}
